/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import ModalPortal from "components-new/ModalPortal";
import sass from "./styles.module.sass";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";

/**
 * Компонент для повторного категорирования выводящая модалку с предложением продолжить или отменить действие
 * @param title - заголовок
 * @param toggle - триггер для включения, отключения модалки
 * @param clickHandler - если нет url должен передаваться clickHandler для кнопки продолжить в появившемся модальном окне
 * @param close - функция отключения модалки
 * @param url - путь на который будет вести кнопка продолжить
 * @param subtitle - Заголовок модалки
 * @constructor
 */
export const ConfirmNavigate: React.FC<{
	title?: string;
	subtitle?: string;
	toggle: boolean;
	close: () => void;
	url?: string;
	clickHandler?: () => void;
}> = ({
	title = "Вы уверены?",
	subtitle = "Изменение поля может повлечь рассинхрозацию данных в системе",
	toggle,
	clickHandler,
	close,
	url,
}) => {
	const navigate = useNavigate();
	return toggle ? (
		<ModalPortal title={title} handleClose={close} outSide={false}>
			<div className={sass.modal}>
				{subtitle && <p className={sass.title}>{subtitle}</p>}
				<div className={sass.btn}>
					<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button
						onClick={() => {
							if (url) {
								navigate(url);
							} else {
								clickHandler && clickHandler();
							}
							close();
						}}>
						Продолжить
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};
